import { createAction } from 'redux-act';

export const findProducts = createAction('findProducts')
export const setSearchResult = createAction('setSearchResult')

export const setSearchString = createAction('setSearchString');